// extracted by mini-css-extract-plugin
export default {"CustomIcon":"Archive__CustomIcon__ZvL_E"};